<template>
    <div class="crud::form-inputs-VSelectComponent">
        <v-select
            key="vSelect"
            ref="vSelect"
            :name="name"
            :options="convertedOptions"
            :filterable="false"
            :multiple="multiple"
            :value="selectedConvertedOptions"
            @search="onSearch"
            @input="onInput($event)"
        >
            <template slot="no-options">Geen keuzes.</template>

            <template v-if="optionSlot" v-slot:option="option">
                <v-runtime-template :template="optionSlot" :template-props="{ option: option.originalOption }" />
            </template>
        </v-select>

        <input
            v-for="selectedValue of selectedValuesArray"
            type="hidden"
            :name="name + (multiple ? '[]' : '')"
            :value="selectedValue"
        />
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VRuntimeTemplate from 'v-runtime-template';

export default {
    components: {
        VRuntimeTemplate,
        vSelect,
    },

    props: {
        name: String,
        required: Boolean,
        multiple: Boolean,
        dataUrl: String,
        valueMapper: [String, Object],
        selected: String | Array,
        optionSlot: String,
    },

    data() {
        return {
            options: null,
            allOptions: null,
            selectedInternal: this.selected,
        };
    },

    mounted() {
        // Init debounced search function.
        this.debouncedSearch = _.debounce(this.search.bind(this), 350);

        this.loadInitialOptions();
    },

    methods: {
        loadInitialOptions() {
            this.onSearch('', this.$refs['vSelect'].toggleLoading);
        },

        onSearch(search, loading) {
            loading(true);

            this.debouncedSearch(loading, search, this);
        },

        search(loading, search) {
            // Shortcut to all options?
            if (search === '' && this.allOptions) {
                this.options = this.allOptions;

                loading(false);
            }
            // Request search?
            else this.searchRequest(loading, search);
        },

        searchRequest(loading, search) {
            axios
                .get(this.dataUrl, {
                    params: { search },
                })
                .then((res) => {
                    this.options = res.data;

                    // Set initial (all) options?
                    if (this.allOptions === null) this.allOptions = res.data;

                    loading(false);
                });
        },

        getValueFromOption(option) {
            return this.internalValueMapper.value
                ? option[this.internalValueMapper.value]
                : option.value || option.code || option.id;
        },

        onInput(selection) {
            if (this.multiple) this.selectedInternal = _.map(selection || [], (item) => item.code);
            else this.selectedInternal = selection ? selection.code : null;
        },

        convertOptions(options) {
            // Map
            return _.map(options, (option) => {
                // Determine code + label.
                let value = '' + this.getValueFromOption(option);
                let label = this.internalValueMapper.label
                    ? option[this.internalValueMapper.label]
                    : (option.name || {}).nl || option.name || option.title || option.value || value;

                return {
                    code: value,
                    label,
                    originalOption: option,
                };
            });
        },
    },

    computed: {
        internalValueMapper() {
            // Unwrap value mapper.
            let valueMapper = {};

            if (this.valueMapper && typeof this.valueMapper == 'object')
                valueMapper = {
                    value: this.valueMapper.value,
                    label: this.valueMapper.label,
                };
            else if (this.valueMapper && typeof this.valueMapper == 'string')
                valueMapper = {
                    label: this.valueMapper,
                };

            return valueMapper;
        },

        // Converts to showable options. Tries the set valueMapper or will guess otherwise.
        convertedOptions() {
            return this.convertOptions(this.options || []);
        },

        convertedAllOptions() {
            return this.convertOptions(this.allOptions || []);
        },

        selectedValuesArray() {
            if (this.multiple) return _.map(this.selectedInternal, (option) => '' + option);
            else {
                if (this.selectedInternal) return ['' + this.selectedInternal];
                else return [];
            }
        },

        selectedConvertedOptions() {
            // Multiple?
            if (this.multiple)
                return _.map(this.selectedValuesArray, (selectedValue) =>
                    _.find(this.convertedAllOptions, { code: selectedValue })
                );
            // Single?
            else {
                if (this.selectedInternal)
                    return _.find(this.convertedAllOptions, { code: this.selectedValuesArray[0] });
                else return null;
            }
        },
    },
};
</script>

<style lang="scss">
// Stop animation for unit tests, otherwhise visual diff see differences within the animation.
html[data-dusk-test] .crud\:\:form-inputs-VSelectComponent .vs__spinner {
    animation: none;
}
</style>
